import { connect, ConnectedProps } from 'react-redux';
import CallLogsSingleCallDetail from './call-logs-single-call-detail';
import { RootState } from '../../../../../../store/root-reducer';
import {
  deleteAttachmentRequest,
  uploadAttachmentRequest,
} from '../../../../../sequence/extra-actions';
import {
  AttachmentDeletePayload,
  AttachmentUploadPayload,
  DELETE_ATTACHMENT_CLIENT_SOURCE_CALL_LOGS_NOTE,
} from '../../../../../sequence/types';
import {
  resetDeleteAttachmentRequest,
  resetUploadAttachmentRequest,
} from '../../../../../sequence/sequence-slice';
import { createCallLogsNotePayload, updateCallLogsNotePayload } from '../../../../types';
import {
  assignCallOutcomeRequest,
  createCallLogsNoteRequest,
  updateCallLogsNoteRequest,
  getPhoneCallMentionableUsersRequest,
} from '../../../../extra-actions';
import {
  resetCreateCallLogsNoteRequest,
  resetUpdateCallLogsNoteRequest,
} from '../../../../dialer-slice';

const mapStateToProps = (state: RootState) => ({
  uploadAttachmentRequestStatus: state.sequence.uploadAttachmentRequest.status,
  uploadAttachmentRequestError: state.sequence.uploadAttachmentRequest.error,
  uploadedAttachment: state.sequence.uploadedAttachment,
  deleteAttachmentRequestStatus: state.sequence.deleteAttachmentRequest.status,
  deleteAttachmentRequestError: state.sequence.deleteAttachmentRequest.error,
  deletedAttachmentId: state.sequence.deletedAttachmentId,
  createCallLogsNoteResponse: state?.dialer?.createCallLogsNoteResponse,
  createCallLogsNoteRequestStatus:
    state?.dialer?.createCallLogsNoteRequest?.status,
  updateCallLogsNoteRequestStatus:
    state?.dialer?.updateCallLogsNoteRequest?.status,
  getPhoneCallMentionableUsersResponse:
    state?.dialer?.getPhoneCallMentionableUsersResponse,
  userTimeZone: state?.home?.timeZone,
});

const mapDispatchToProps = {
  handleSendAttachmentUploadRequest: (payload: AttachmentUploadPayload) =>
    uploadAttachmentRequest(payload),
  handleResetUploadAttachmentRequest: () => resetUploadAttachmentRequest(),
  handleSendDeleteAttachmentRequest: (payload: AttachmentDeletePayload) =>
    deleteAttachmentRequest({
      ...payload,
      clientSource: DELETE_ATTACHMENT_CLIENT_SOURCE_CALL_LOGS_NOTE,
    }),
  handleResetDeleteAttachmentRequest: () => resetDeleteAttachmentRequest(),
  handleCreateCallLogsNoteRequest: (payload: createCallLogsNotePayload) =>
    createCallLogsNoteRequest(payload),
  handleUpdateCallLogsNoteRequest: (payload: updateCallLogsNotePayload) =>
    updateCallLogsNoteRequest(payload),
  resetUpdateCallLogsNoteRequest: () => resetUpdateCallLogsNoteRequest(),
  handleGetPhoneCallMentionableUsersRequest: (callId: number) =>
    getPhoneCallMentionableUsersRequest(callId),
  sendAssignCallOutcomeRequest: (outcomeId: number, dialerCallLogId: number) =>
    assignCallOutcomeRequest({ outcomeId, dialerCallLogId }),
  resetCreateCallLogsNoteRequest: () => resetCreateCallLogsNoteRequest(),
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type IReportsProps = ConnectedProps<typeof connector>;

export default connector(CallLogsSingleCallDetail);
